import { render, staticRenderFns } from "./select-model-modal.vue?vue&type=template&id=5cb9740a&scoped=true&"
import script from "./select-model-modal.vue?vue&type=script&lang=ts&"
export * from "./select-model-modal.vue?vue&type=script&lang=ts&"
import style0 from "./select-model-modal.vue?vue&type=style&index=0&id=5cb9740a&prod&lang=less&scoped=true&"
import style1 from "./select-model-modal.vue?vue&type=style&index=1&id=5cb9740a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb9740a",
  null
  
)

export default component.exports